import { TextCodes } from '@api/types/translation/TextCodes';
import { Button } from '@components';
import { Box, Container, Link, Typography } from '@mui/material';
import { t } from '@translations';

/**
 * Generic loading error displayed when API connection fails.
 * TODO [KF]: use translation here
 */
export const GenericError = () => (
  <Box sx={{ py: 2 }}>
    <Typography component='h1' variant='h4'>
      Something went wrong
    </Typography>
    <Box sx={{ pb: 4 }}>{t(TextCodes.Base.GenericError.ErrorLoadingData)}</Box>
    <Link href='mailto:admin@berema.no'>
      <Button variant='primary'>{t(TextCodes.Base.GenericError.ContactUs)}</Button>
    </Link>
  </Box>
);

export const GenericErrorPage = () => (
  <Box sx={{ height: '100vh' }}>
    <Container>
      <GenericError />
    </Container>
  </Box>
);
